
$(document).ready(function () {
  $(function () {
    $('.swatch :radio').change(function () {
      var optionIndex = $(this).closest('.swatch').attr('data-option-index');
      var optionValue = $(this).val();
      $(this)
        .closest('form')
        .find('.single-option-selector')
        .eq(optionIndex)
        .val(optionValue)
        .trigger('change');
    });
  });
  $(window).load(function () {
    $('.selector-wrapper:eq()').hide();
    setTimeout(function () {
      $('.owl-carousel-product-recommendations').owlCarousel({
        loop: true,
        margin: 0,
        responsiveClass: true,
        responsive: {
          0: {
            items: 2,
            nav: true
          },
          600: {
            items: 2,
            nav: true
          },
          1900: {
            items: 3,
            nav: true,
            loop: false
          }
        }
      });
      $('.owl-carousel-home').owlCarousel({
        loop: true,
        margin: 20,
        dot: true,
        responsiveClass: true,
        responsive: {
          0: {
            items: 2,
            nav: false,
            margin: 10
          },
          600: {
            items: 3,
            nav: false
          },
          1000: {
            items: 4,
            nav: false,
            loop: false
          },
          1440: {
            items: 5,
            nav: false,
            loop: false
          }
        }
      });
      $('.owl-carousel-custom').owlCarousel({
        loop: false,
        margin: 0,
        dot: false,
        responsiveClass: true,
        nav: true,
        items: 1,
        responsive: {
          0: {
            items: 1,
            nav: true,
            margin: 10,
            dot: false
          },
          992: {
            items: 1,
            nav: true,
            dot: false
          }
        }
      })
    }, 800);
  });

  $(window).load(function () {
    // Get the modal
    var modal = document.getElementById('myModal');

    // Get the button that opens the modal
    var btn = document.getElementById("myBtn");

    // Get the <span> element that closes the modal
    var span = document.getElementsByClassName("close")[0];
    var headermodaltext = document.getElementById("headerforfabric");
    // When the user clicks the button, open the modal 
    if (typeof (btn) != 'undefined' && btn != null) {
      btn.onclick = function () {
        modal.style.display = "block";
        $('body').addClass("hidden");
        //add scroll to table
        $(window).on("resize", function (e) {
          checkScreenSize();
        });

        checkScreenSize();

        function checkScreenSize() {
          var newWindowWidth = $(window).width();
          if (newWindowWidth < 768) {
            var customScrollbarTable = document.querySelector('.ps-default');
            var ps = new PerfectScrollbar(customScrollbarTable);
            var customScrollbarTable1 = document.querySelector('.ps-default1');
            var ps = new PerfectScrollbar(customScrollbarTable1);
          }
        };
      }
    }

    // When the user clicks on <span> (x), close the modal
    if (typeof (span) != 'undefined' && span != null) {
      span.onclick = function () {
        modal.style.display = "none";
        $('body').removeClass("hidden");
      }
    }

    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function (event) {
      if (event.target == modal) {
        if (typeof (modal) != 'undefined' && modal != null) {
          modal.style.display = "none";
          $('body').removeClass("hidden");
        }
      }
    }
  });

  //mobile footer menu
  $('.title-block').on('click', function () {
    $(this).parent().toggleClass('active');
    if ($('.title-block').parent().hasClass('active')) {
      $('.title-block').parent().removeClass('active');
      $(this).parent().addClass('active');
    }
  });
  //go to top
  $(window).scroll(function () {
    if ($(this).scrollTop()) {
      $('.site-header-wrapper').css('top', '0px')
      $('#toTop').fadeIn();
    } else {
      $('.site-header-wrapper').css('top', '33px')
      $('#toTop').fadeOut();
    }
  });
  $("#toTop").click(function () {
    $("html, body").animate({ scrollTop: 0 }, 1000);
  });

  //photoswipe init
  var container = [];

  // Loop over gallery items and push it to the array
  $('a.photoswipe__gallery').each(function () {
    var $link = $(this),
      item = {
        src: $link.attr('href'),
        w: 1920,
        h: 1680,
        title: $link.data('caption')
      };
    container.push(item);
  });

  // Define click event on gallery item
  $('a.photoswipe__gallery').click(function (event) {

    // Prevent location change
    event.preventDefault();

    // Define object and gallery options
    var $pswp = $('.pswp')[0],
      options = {
        index: $('a.photoswipe__gallery').index(this),
        bgOpacity: 0.85,
        showHideOpacity: true
      };
    // Initialize PhotoSwipe
    var gallery = new PhotoSwipe($pswp, PhotoSwipeUI_Default, container, options);
    gallery.init();
  });


  //hover image
  $(document).on('mouseenter', '.product-item__link-wrapper img', function () {
    const hoverImage = $(this).data('hover-image');
    if (hoverImage) {
      $(this).attr('src', hoverImage);
    }
  });
  $(document).on('mouseleave', '.product-item__link-wrapper img', function () {
    if ($(this).data('original-image')) {
      $(this).attr('src', $(this).data('original-image'));
    }
  });

  //force filter translation
  setTimeout(function () {
    if (document.documentElement.lang == 'en') {
      $('body').find(".boost-pfs-filter-option-title-text").each(function () {
        console.log($(this).text());
        if ($(this).text() == 'Colore') {
          $(this).text('Color');
        } else {
          if ($(this).text() == 'Taglia') {
            $(this).text('Size');
          }
        }
      });
    }

  }, 1000);
});


$(document).ready(function () {
  if (window.location.href.indexOf("/en.") > -1) {
    $('.lang-en').addClass('active');
    $('.locale-en').show();
    $('.locale-it').hide();
    $('body').find(".hero__dots").each(function () {
      console.log($(this).text());
      console.log('0asa');
      if ($(this).text() == 'Donna') {
        $(this).text('Woman');
      } else {
        if ($(this).text() == 'Uomo') {
          $(this).text('Man');
        }
      }
    });
  } else {
    $('.lang-it').addClass('active');
    $('.locale-en').hide();
    $('.locale-it').show();
  }

  //tabs carousel home page
  $('.tab').click(function () {
    $('.tab').removeClass('active');
    $(this).addClass('active');
    $('.oxs-home-carousel').toggleClass("hide");
  });
});
//cart click privacy
function cartPrivacyToggle(el, mini) {
  var privacy = $(el)
  var cart = (mini ? $('#checkout-minicart') : $('#checkout-cart'));
  if (privacy.prop('checked') == true) {
    cart.prop("disabled", false);
  } else {
    cart.prop("disabled", true);
  }
}

//cart click privacy
function cartPrivacyToggle(el, mini){
    var privacy = $(el)
    var cart = (mini ? $('#checkout-minicart') : $('#checkout-cart'));
    if(privacy.prop('checked') == true){
      cart.prop("disabled", false);
   } else{
      cart.prop("disabled", true);
   }  
  }
  
  //newsletter click privacy
  function newsletterPrivacyToggle(){
      var privacynews = $('.checknews')
      var send = $('.newsletter__submit');
      if(privacynews.prop('checked') == true){
          privacynews.attr('checked', 'checked')
          privacynews.checked = true
          $('.whitechk').addClass('chkactive')
          send.prop("disabled", false);
      } else{
          privacynews.removeAttr('checked');
          privacynews.checked = false
          $('.whitechk').removeClass('chkactive')
          send.prop("disabled", true);
      }  
  }


/**
 * Scroll indicator for product gallery
 */
var myProductGalleryScroller = {
  init: function () {
    this.imagesActions();
  },
  getImages: function () {
    return $(".product-page-media .medium-up--one-half");
  },
  imagesActions: function () {
    $imgLi = this.getImages();

    //NAVIGAZIONE LISTA IMMAGINI
    var $nav = $("#img-nav");
    var $div = $("<div/>");

    $imgLi.each(function (index, el) {
      var $span = $("<span class='id" + index + "'><hr /></span>");
      $span.appendTo($div);
    });

    $div.appendTo($nav);

    //CLICK E SCROLL        
    $link = $("span", $nav);

    $link.click(function () {
      var id = $(this).index();

      var $img = $imgLi.eq(id);
      $('html,body').animate({ scrollTop: $img.offset().top }, 500);
    });

    this.getImageOnViewport($link);
  },
  getImageOnViewport: function ($link) {
    var $win = $(window);

    function checkViewport() {
      myProductGalleryScroller.getImages().each(function (i, e) {
        var $e = $(e);
        var elmH = $e.height();
        var elmT = $e.offset().top;
        if (elmT < ($win.scrollTop() + $win.height() / 2)) {
          $link.removeClass("active");
          $link.eq($e.index() - 1).addClass("active");
        }
      });
    }
    checkViewport();

    $win.bind('scroll', function (e) {
      checkViewport();
    });
  }
}

theme.ProductGalleryScrollerSection = (function () {
  function ProductGalleryScroller() {
    myProductGalleryScroller.init();
  }

  return ProductGalleryScroller;
})();
/**
 * goto link customer page
 */
theme.CustomerServiceActions = (function () {
  var $container = $("#ord-list-custom");
  if ($container.length > 0) {
    var offset = $(".main-container").offset();
    var $child = $(">div", $container);
    if ($(window).width() > 767) {
      $container.stick_in_parent({
        parent: $("#condizioni"),
        offset_top: offset
      });
    }
    var $link = $("a", $container);
    $link.click(function (ev) {
      $link.removeClass("active");
      $(this).addClass("active");
    });
  }
})();

/**
 * custom menu
 */
theme.CustomMenu = (function () {
  var $link = $(".drawer-nav__toggle");
  var $expanded = 'drawer-nav--expanded';
  var $submenuexpanded = 'submenu-expanded';
  var $child = $('.drawer-nav__sublist');

  if ($(window).width() > 767) {
    $link.mouseenter(function () {
      if ($link.parent().hasClass($expanded)) {
        $link.parent().removeClass($expanded);
        $(this).parent().addClass($expanded);
        $('.drawer__inner').addClass($submenuexpanded).scrollTop(0);
      } else {
        $(this).parent().addClass($expanded);
      }
    });

    $link.mouseleave(function () {       
      $child.mouseenter(function () {        
        $link.parent().addClass($expanded);
      });
      $child.mouseleave(function () {        
        $link.parent().removeClass($expanded);
      });
      $(this).parent().removeClass($expanded);      
    });
   
  } else {
    $link.on('click', function () {
      if ($link.parent().hasClass($expanded)) {
        $link.parent().removeClass($expanded);
        $(this).parent().addClass($expanded);
        $('.drawer__inner').addClass($submenuexpanded).scrollTop(0);
      }
      $('.custom-menu').on('mousewheel', function (e) { e.preventDefault(); e.stopPropagation(); });
    });
    $('.back').on('click', function () {
      $link.parent().removeClass($expanded);
      $('.drawer__inner').removeClass($submenuexpanded);
    });
  }
})();

/**
 * remove a aaaa
 */

theme.CustomWishlistCollection = (function () {
  $('a.product-item__link').children().each(function(){
    $(this).click(function(e){
      console.log('heart');
        e.preventDefault();
    });
});
});

$(document).ready(function () {
  // theme.init();
  var sections = new theme.Sections();
  sections.register('product-gallery-scroller-section', theme.ProductGalleryScrollerSection);
  sections.register('customer-service-section', theme.CustomerServiceActions);
  sections.register('header', theme.CustomMenu);
  sections.register('collection-template', theme.CustomWishlistCollection);
});
